import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronDown,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons';
import { LedgerEntry } from './PatientDetailsConstant';
import PaginationController from 'src/latest/src/components/PaginationController';
import { formatBusinessDateMMDDYYYY } from 'src/legacy/utils/helpers';
import CustomPopOver from 'src/containers/QuestionnaireParent/QuestionOptionsLibrary/components/CustomPopOver/CustomPopOver';

interface PatientLedgerProps {
  ledgerEntries: LedgerEntry[];
  toggleRowExpansion: (index: number) => void;
  currentPage: number;
  setCurrentPage: (page: number) => void;
  totalPages: number;
  children: React.ReactNode;
  content: React.ReactNode;
}

const PatientLedger: React.FC<PatientLedgerProps> = ({
  ledgerEntries,
  toggleRowExpansion,
  currentPage,
  setCurrentPage,
  totalPages,
  children,
  content,
}) => {
  return (
    <div className="patient-ledger">
      <div className='ledger-header'>
        <h2 className="ledger-title">Patient Ledger</h2>
        <CustomPopOver
          content={content}
          placement="top"
          classname="filter-wrapper"
          title={''}
        >
          {children}
        </CustomPopOver>
      </div>
      <table className="ledger-table">
        <thead>
          <tr>
            <th style={{ width: '5%' }} />
            <th>CPT Code</th>
            <th>Service Date</th>
            <th>Provider</th>
            <th>Charge Amt</th>
            <th>Applied Amt</th>
            <th>Patient Bal.</th>
            <th>Insurance Bal.</th>
            <th>Total Bal.</th>
          </tr>
        </thead>
        <tbody>
          {ledgerEntries.map((entry, index) => (
            <React.Fragment key={index}>
              <tr className="ledger-main-row">
                <td
                  className="expand-icon"
                  onClick={() => toggleRowExpansion(index)}
                >
                  {entry.details && entry.details?.length > 0 && (
                    <FontAwesomeIcon
                      icon={entry.isExpanded ? faChevronDown : faChevronRight}
                    />
                  )}
                </td>
                <td>{entry.cptCode}</td>
                <td>{formatBusinessDateMMDDYYYY(entry.serviceDate)}</td>
                <td>{entry.provider || '-'}</td>
                <td>
                  {entry.chargeAmt ? `$${entry.chargeAmt.toFixed(2)}` : '$0.00'}
                </td>
                <td>
                  {entry.appliedAmt
                    ? `$${Math.abs(entry.appliedAmt).toFixed(2)}`
                    : '$0.00'}
                </td>
                <td>
                  {entry.patientBal
                    ? `$${entry.patientBal.toFixed(2)}`
                    : '$0.00'}
                </td>
                <td>
                  {entry.insuranceBal
                    ? `$${entry.insuranceBal.toFixed(2)}`
                    : '$0.00'}
                </td>
                <td>
                  {entry.totalBal ? `$${entry.totalBal.toFixed(2)}` : '$0.00'}
                </td>
              </tr>
              {entry.isExpanded &&
                entry.details?.map((detail, detailIndex) => (
                  <tr
                    key={`${index}-${detailIndex}`}
                    className="ledger-detail-row"
                  >
                    <td />
                    <td className="detail-type">{detail.type}</td>
                    <td>{formatBusinessDateMMDDYYYY(detail.serviceDate)}</td>
                    <td />
                    <td />
                    <td className="detail-applied-amt">
                      {detail.appliedAmt
                        ? `$${Math.abs(detail.appliedAmt).toFixed(2)}`
                        : '$0.00'}
                    </td>
                    <td />
                    <td />
                    <td />
                  </tr>
                ))}
            </React.Fragment>
          ))}
        </tbody>
      </table>
      <div className="pagination-container">
        <PaginationController
          totalNoOfPages={totalPages}
          activePage={currentPage}
          onPageChange={page => setCurrentPage(page)}
        />
      </div>
    </div>
  );
};

export default PatientLedger;
